import {
  SdColorBackgroundContainer,
  SdColorBackgroundContainerChildResult,
  Typenames,
} from '@varo/graphql-schema-types';
import React from 'react';
import { View } from 'react-native';
import fullWidthTextComponent from 'shared/legacySDUIAdapters/fullWidthTextComponent';
import vxlSpacing from 'shared/legacySDUIAdapters/vxlSpacing';
import Renderer from 'shared/renderer';
import { VXLNode } from 'shared/renderer/types';
import { Maybe } from 'shared/utils/types';

const sdColorBackgroundContainerChild = (
  element: SdColorBackgroundContainerChildResult,
  index: number,
): Maybe<VXLNode> => {
  switch (element.__typename) {
    case Typenames.SpacingComponent:
      return vxlSpacing(element, index);
    case Typenames.FullWidthTextComponent:
      return fullWidthTextComponent(element);
    default:
      return null;
  }
};

const sdColorBackgroundContainer = (
  component: SdColorBackgroundContainer,
): VXLNode => {
  return {
    id: component.id,
    render: () => {
      return (
        <View>
          {component.children.map((element, index) => {
            const node = sdColorBackgroundContainerChild(element, index);
            return <Renderer key={element.id} toRender={node ?? undefined} />;
          })}
        </View>
      );
    },
  };
};

export default sdColorBackgroundContainer;
